/**
 * Maps URL paths to appropriate page titles and types for the Event API.
 * This function parses the URL hash to determine the current page.
 * @returns {{title: string, type: string}} An object containing the formatted page title and a derived page type.
 */
const APP_TYPE = "ethernet";

export const transformTitleTypeAndMapUrl = () => {
  const { hash, hostname } = window.location;

  let appType = APP_TYPE;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  // Determine appType from subdomain if not on localhost
  if (!isLocalhost) {
    const hostnameSegments = hostname.split(".");
    // Assuming subdomain is the first part, e.g., 'ethernet.boingo.com'
    if (hostnameSegments.length >= 3) {
      appType = hostnameSegments[0];
    }
  }

  // Get the path from the hash, removing the leading '#/' and any query params.
  let pathForMatching = "";
  if (hash.startsWith("#")) {
    // Get the part after '#' and before '?'
    let hashPath = hash.substring(1).split("?")[0];
    // Remove leading slash if it exists, e.g., from '/venue/signup' to 'venue/signup'
    if (hashPath.startsWith("/")) {
      hashPath = hashPath.substring(1);
    }
    pathForMatching = hashPath;
  }

  const appTypeLower = appType.toLowerCase();

  // Define mappings from URL patterns to page titles and types.
  // The patterns match against the path inside the hash (e.g., 'lax/signup-form').
  const mappings = {
    ethernet: [
      // Matches /store
      {
        pattern: /^store$/,
        title: "Boingo Ethernet - Store",
        type: "store",
      },
      // Matches empty hash, #/, or #/venueId
      {
        pattern: /^(?:[^\/]+\/?)?$/,
        title: "Boingo Ethernet - Landing",
        type: "landing",
      },
      // Matches /venueId/signup-form
      {
        pattern: /^[^\/]+\/signup-form$/,
        title: "Boingo Ethernet - Sign Up",
        type: "signup",
      },
      // Matches /venueId/payment
      {
        pattern: /^[^\/]+\/payment$/,
        title: "Boingo Ethernet - Checkout",
        type: "checkout",
      },
      // Matches /venueId/welcome
      {
        pattern: /^[^\/]+\/welcome$/,
        title: "Boingo Ethernet - Welcome",
        type: "welcome",
      },
      // Matches /venueId/error
      {
        pattern: /^[^\/]+\/error$/,
        title: "Boingo Ethernet - Error",
        type: "error",
      },
    ],
  };

  // Find the first matching pattern for the current app type.
  if (mappings[appTypeLower]) {
    const match = mappings[appTypeLower].find((mapping) =>
      mapping.pattern.test(pathForMatching)
  );
    if (match) {
      return { title: match.title, type: match.type };
    }
  }

  // Most generic fallback (e.g., for an unrecognized root path)
  return { title: `Boingo ${appTypeLower}`, type: "unknown" };
};

export default transformTitleTypeAndMapUrl;
